"use strict";

PF.Field.CheckGroup = class CheckGroup extends PF.Field
	{
	static get options()
		{
		return {
			listConfig: {
				html: {
					wrapper: PF.Field.CheckGroup.templates.listWrapper,
				},
				models: undefined,
				modelsConfig: {
					loadOnInit: false
				},
				itemClass: PF.Field.CheckGroup.Item,
				title: 'Название',
				showRemoved: true
			},
			selectedModelsConfig: {},
			model: new PF.Model({}),
			key: 'value',

			showInfo: true,
			helper: '',
			simpleName: '@{model.name}',

			selectAllBox: true,

			minCount: 0,
			maxCount: Infinity,
			fixCount: undefined,
			deletePolicy: 'deleteByFlag', //delete, deleteByFlag, unlinkByFlag
			errors: {
				minCount: (self) => `Выберите ${Util.spell(self.minCount, ['', '@{v} значение', '@{v} значения', '@{v} значений'])}`,
				maxCount: (self) => `Выберите не более ${Util.spell(self.minCount, ['', '@{v} значения', '@{v} значений', '@{v} значений'])}`,
				fixCount: (self) => `Выберите ${Util.spell(self.minCount, ['', '@{v} значение', '@{v} значения', '@{v} значений'])}`
			}
		};
		}


	static get templates()
		{
		return {
			//language=HTML
			listWrapper: `				
				${PF.List.templates.wrapper}
				<div class="info" pf="info">&nbsp</div>
			`,
		};
		}


	init()
		{
		if (this.dict !== undefined)
			{
			this.listConfig.modelsConfig.raw = this.model.dicts[this.dict];
			}


		this.name = 'check-' + PF.H.randomString();

		if (this.model.get(this.key, null, null) === null)
			{
			this.model.setData(this.key, new PF.Models({parent: this.model, ...this.selectedModelsConfig}), true);
			this.selectedModels = this.model.get(this.key);
			}
		else
			{
			this.selectedModels = this.model.get(this.key);
			PF.Options.assignOptions(this.selectedModels, this.selectedModelsConfig);
			}
		this.model.get(this.key).deletePolicy = this.deletePolicy;

		this.list = new PF.List({
			dom: this.dom,
			...this.listConfig,
			group: this
		});
		this.list.models.loadPart();

		this.dom.element.classes.checkGroup = true;
		this.bindDom({wrapper: 'class:error'}, 'error', (e) => e !== '');
		this.bindDom({info: 'html'}, ['helper', 'error'], (h, e) => e !== '' ? e : h !== '' ? h : '&nbsp;');
		this.bindDom({info: 'show'}, 'showInfo');

		this.selectedModels.on(['changed', 'load-part'], () => {
			this.setSelectedStates();
			this.validate(true);
		}, true);

		// this.list.models.on(, () => {
		// 	this.setSelectedStates();
		// 	this.validate(true);
		// });

		if (this.selectAllBox === true)
			{
			this.selectAllItem = new PF.Field.CheckGroup.SelectAllItem({list: this.list, group: this, dom: {ul: this.dom.ul}});
			this.list.on('add', () => {
				this.list.dom.ul.prepend(this.selectAllItem.dom.item);
			});
			}

		this.list.on('add-success', (newModel, newItem) => {
			newItem.selectState = true;
		});
		}

	setSelectedStates()
		{
		for (let i = 0; i < this.list.length; i++)
			{
			let isSelected = false;
			for (let j = 0; j < this.selectedModels.length; j++)
				{
				if (PF.H.compareByPks(this.selectedModels[j], this.list[i].model) && this.selectedModels[j].options.removed !== true)
					{
					if (this.selectedModels[j] !== this.list[i].model)
						{
						this.selectedModels[j].populateData(this.list[i].model);
						}
					isSelected = true;
					break;
					}
				}
			// console.log(this.list[i].model.get('name'), 'setSelectedStates', isSelected);
			this.list[i].selectState = isSelected === true;
			}
		}


	validate(silent, error)
		{
		let count = 0;
		for (let i = 0; i < this.selectedModels.length; i++)
			{
			if (this.selectedModels[i].removed !== true)
				{
				count++;
				}
			}

		if (this.required)
			{
			if (count === 0)
				{
				return super.validate(silent, this.errors.required);
				}
			}
		if (count < this.minCount)
			{
			return super.validate(silent, this.errors.minCount);
			}
		if (count > this.maxCount)
			{
			return super.validate(silent, this.errors.maxCount);
			}
		if (this.fixCount !== undefined)
			{
			if (count !== this.fixCount)
				{
				return super.validate(silent, this.errors.fixCount);
				}
			}

		return super.validate(silent, error);
		}
	};


PF.Field.CheckGroup.Item = class Item extends PF.List.Item
	{
	static get options()
		{
		return {};
		}

	get renderer()
		{
		//language=HTML
		return `
			<li pf="item">
				<label class="item-checkbox item-content" for="null" pf="label">
					<input type="checkbox" name="" value="" pf="input">
					<i class="icon icon-checkbox"></i>
				
					${this.itemInner}
				</label>
			</li>
		`;
		}

	get itemInner()
		{
		//language=HTML
		return `
			<div class="item-inner">
				<div class="item-title" >
					${this.list.group.simpleName}
				</div>
			</div>`;
		}

	onRender(event)
		{
		super.onRender(event);

		this.dom.input.bindValue();
		this.dom.input.bindAttributes();

		// this.calc('selectState', 'dom.input.value');
		// this.calc('dom.input.value', 'selectState');

		this.connect('dom.input.value', 'selectState');

		this.dom.item.on('click', () => this.selectState = !this.selectState);

		this.selectState = this.list.group.selectedModels.findByModel(this.model) !== undefined;

		this.onValue('selectState', true, () => {
			this.list.group.selectedModels.addModel(this.model);
		});
		this.onValue('selectState', false, () => {
			this.list.group.selectedModels.removeModel(this.model);
		});
		}
	};


PF.Field.CheckGroup.SelectAllItem = class SelectAllItem extends PF.Widget
	{
	static get options()
		{
		return {
			dom: {ul: undefined}
		};
		}

	get template()
		{
		//language=HTML
		return `
			<li class="select-all">
				<label class="item-checkbox item-content" pf="label">
					<input type="checkbox" pf="input">
					<i class="icon icon-checkbox"></i>
					<div class="item-inner">
						<div class="item-title" pf="title">Все</div>
					</div>
				</label>
			</li>
		`;
		}

	init()
		{
		super.init();
		this.dom.load(this.template, 'item');
		this.dom.ul.prepend(this.dom.item);

		this.group.selectedModels.onFinish('changed', () => {
			if (this.group.selectedModels.notRemovedCount === 0)
				{
				this.state = 'none';
				}
			else if (this.group.selectedModels.notRemovedCount === this.group.list.models.filterLength)
				{
				this.state = 'all';
				}
			else
				{
				this.state = 'part';
				}
		}, 100, true);

		this.dom.item.bindClasses();
		this.calc('dom.item.classes.state', 'state');

		this.dom.item.on('click', () => {
			this.selectAll(this.state === 'none');
		});

		this.dom.input.bindValue();
		this.calc('dom.input.value', 'state', (s) => s !== 'none');
		}


	selectAll(select)
		{
		for (let i = 0; i < this.list.length; i++)
			{
			this.list[i].selectState = select;
			}
		}

	};